import {
  Stack,
  Tabs,
  Tab,
  Typography,
  Box,
} from '@mui/material';
import React from 'react';
import {
  useLocation,
  useHistory,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import DashboardHeader from '@/@mui/dashboard/DashboardHeader';
import { PMPRoutes } from '@/config/routes';

import InboundMessagesWithTenantsSubpage from './inbound-messages/InboundMessagesWithTenantsSubpage';
import InboundMessagesWithVendorsSubpage from './inbound-messages/InboundMessagesWithVendorsSubpage';

const InboundMessagesViewPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    history.push(newValue);
  };

  return (
    <Stack direction="column" spacing={2} sx={{ flex: '1 1 100%' }}>
      <DashboardHeader hasInnerHtml title="Messages: <em>Inbound</em>" />

      <Typography variant="dataGridBody">
        View and manage inbound messages from tenants and vendors.
      </Typography>

      <Tabs
        value={
          location.pathname === PMPRoutes.inboundMessagesWithVendors
            ? PMPRoutes.inboundMessagesWithVendors
            : PMPRoutes.inboundMessagesWithTenants
        }
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Tenants" value={PMPRoutes.inboundMessagesWithTenants} />
        <Tab label="Vendors" value={PMPRoutes.inboundMessagesWithVendors} />
      </Tabs>

      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 3,
          backgroundColor: 'secondary.lighter',
          minHeight: '400px',
        }}
      >
        <Switch>
          <Route
            exact
            path={PMPRoutes.inboundMessagesWithTenants}
            component={InboundMessagesWithTenantsSubpage}
          />
          <Route
            exact
            path={PMPRoutes.inboundMessagesWithVendors}
            component={InboundMessagesWithVendorsSubpage}
          />
          <Redirect to={PMPRoutes.inboundMessagesWithTenants} />
        </Switch>
      </Box>
    </Stack>
  );
};

export default InboundMessagesViewPage;
